import {EntityArray} from '../../core/entityArray';
import {IMessageRequestChangeResponse} from '../../interfaces/socket.interface';

import {Message} from './message';

/**
 * Message collection
 *
 * @category Message Entity
 * */
export class Messages extends EntityArray<Message> {

  // @todo move more things to here

  /**
   * This method will update all replied messages on each message entity
   *
   * @param items list of changes
   * */
  updateReplies(items: IMessageRequestChangeResponse[] = []) {
    if (this.length) {

      items.forEach((item) => {
        this.forEach((message) => {

          // if (message.content.replyToMessage) {
          //   console.log('updateReplies', message.content.replyToMessage, item.message.id, message.content.replyToMessage.id)
          // }

          if (message.content.replyToMessage && item.message.id === message.content.replyToMessage.id) {
            message.content.replyToMessage?.update(item.message, item.type);
          }
        })
      })

    }
  }
}
